import gmt from './gmt';

export default {
  mixins: [gmt],
  methods: {
    img(asset) {
      return this.$options.filters.macModelImage(asset.modelName);
    },
    assetLink(asset) {
      return {
        name: 'assets.index.dashboard',
        params: { id: asset.uuid },
      };
    },
    latestProfile(asset) {
      if (asset.profile) {
        return asset.profile.hash === asset.configHash;
      }
      return false;
    },
    keyValues(asset) {
      return [
        {
          label: 'Label',
          value: asset.label,
        },
        {
          label: 'Tags',
          value: ((asset.tags !== null) ? asset.tags.join(', ') : ''),
          // value: asset.tags.join(', '),
        },
        {
          label: 'Host Name',
          value: asset.hostName,
        },
        {
          label: 'Last Connected',
          value: this.$options.filters.formatEpochDate(asset.checkin, this.gmt),
        },
        {
          label: 'Serial',
          value: asset.serial,
        },
        {
          label: 'Model',
          value: asset.modelName,
        },
        {
          label: 'macOS',
          value: asset.osString,
        },
        {
          label: 'Device ID',
          value: asset.uuid,
        },
        {
          label: 'Profile',
          value: ((asset.profile !== null) ? asset.profile.name : 'None'),
        },
        {
          label: 'GP Version',
          value: ((asset.version !== null) ? asset.version : 'Unknown'),
        },
      ];
    },
  },
};
